import Button from '@material-ui/core/Button';
import axios from 'axios';
import { withSnackbar } from 'notistack';
import React, { Component } from 'react';
import "react-datepicker/dist/react-datepicker.css";
import { handleChangeEvent, handlePost } from '../../../utils/AxiosUtil';
import * as util from '../../../utils/Util';
import ErrorAwareBankAccountField from '../../common/inputfields/ErrorAwareBankAccountField';
import ErrorAwareDatePicker from '../../common/inputfields/ErrorAwareDatePicker';
import MyAutocomplete from '../../common/inputfields/MyAutocomplete';
import NewAgainField from '../../common/inputfields/NewAgainField';

class NewBankAccountNumber extends Component {

    state = {
        newAgain: false,
        selectedPartner: {},
        bankAccountNumber: '',
        validFrom: null,
        partnerDisabled: false,
        errors: new Map(),
    }

    componentWillMount() {
        if (this.props.row) {
            console.log(this.props.row);
            const partner = this.props.row.employee ? { label: this.props.row.employee.name, value: this.props.row.employee.privateId } :
                { label: this.props.row.name, value: this.props.row.privateId }
            this.setState({ partnerDisabled: true, selectedPartner: partner })
        }
    }

    resetForm = () => {
        this.setState({
            newAgain: false,
            selectedPartner: {},
            bankAccountNumber: '',
            validFrom: null,
            errors: new Map()
        })
    }

    handleSubmit = async (event) => {
        event.persist()
        event.preventDefault();
        const path = '/api/bankaccountnumber';
        const requestObject = {
            "customerId": this.state.selectedPartner.value,
            "bankAccountNumber": util.trimSpaces(this.state.bankAccountNumber),
            "validFrom": this.state.validFrom,
        };
        console.log(requestObject);
        await handlePost(path, requestObject, this);
    };

    promisePartnerOptions = async () => {
        const response = await axios.get('/api/partners')
        const renamedCustomers = [];
        response.data.map((partner) =>
            renamedCustomers.push({
                label: partner.name,
                value: partner.privateId,
            }));
        return renamedCustomers;
    };

    handlePartnerSelected = (e, v) => {
        this.setState({ selectedPartner: v })
    }

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <div className='flex-form'>
                    <div className='input-group'>
                        <MyAutocomplete
                            defaultValue={this.state.selectedPartner}
                            disabled={this.state.partnerDisabled}
                            getOptions={this.promisePartnerOptions}
                            onChange={this.handlePartnerSelected}
                            label={'Partner'}
                        />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareBankAccountField
                            required
                            name="bankAccountNumber"
                            label="Bankszámlaszám"
                            errors={this.state.errors}
                            value={this.state.bankAccountNumber}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareDatePicker
                            name="validFrom"
                            label="Érvényesség kezdete"
                            errors={this.state.errors}
                            value={this.state.validFrom}
                            onChange={event => this.setState({ validFrom: event })} />
                    </div>
                </div>
                <div className="form-actions">
                    {/**if it is open from another page than bankAccountNumber */}
                    {this.state.partnerDisabled ? <></> :
                        <NewAgainField
                            checked={this.state.newAgain}
                            onChange={e => this.setState({ newAgain: e.target.checked })} />}
                    <Button className="btn-submit" variant="contained" color="primary" type="submit">
                        Hozzáadás
                    </Button>
                </div>
            </form>
        )
    }
}

export default withSnackbar(NewBankAccountNumber);
